<div class="mb-5">
  <h2 class="font-medium text-lg mb-2 text-[#15191E]">Add Hours</h2>
  <p class="font-normal text-sm text-[#60646C]">Enter the number of hours worked by the team member.</p>
</div>


<div *ngIf="assigned()" class="border border-[#F1F1F4] rounded-lg">
  <cdk-accordion class="w-full">
    <cdk-accordion-item *ngFor="let item of assignees; let i = index" [expanded]="expandedIndex === i">

      <!-- Accordion Header Start -->
      <div
        class="flex justify-between lg:items-center items-start flex-col lg:flex-row border-b gap-2.5 border-[#EFF0F5] py-[14px] px-4 {{expandedIndex === i ? 'bg-[#FBFBFC]' : '' }}"
        tabindex="0" role="button" [attr.aria-expanded]="expandedIndex === i"
        [attr.aria-controls]="'accordion-body-' + i" [attr.id]="'accordion-header-' + i">
        <div class="flex items-center gap-2 flex-1">
          <app-avatar [userList]="[{ displayName: item.fullName , pic: item?.pic}]" [size]="'sm'" [showTooltip]="false"></app-avatar>
          <h3 class="font-medium text-sm text-[#15191E]">{{ item?.fullName }}</h3>
        </div>
        <div class="flex items-end gap-2.5 flex-1 !lg:justify-end justify-between w-full">

          <div class="flex lg:gap-2.5 gap-1.5 lg:flex-row flex-col flex-1 lg:justify-end justify-start items-start">
            <div class="min-w-[90px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#EFF6FF]">
              <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                Est:<span
                  class="font-medium text-[#15191E] inline-block">{{formatHeaderValue(item?.emHours)}}h</span>
              </p>
            </div>
            <div class="min-w-[118px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#F0FDF4]">
              <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                Regular:<span
                  class="font-medium text-[#15191E] inline-block">{{formatHeaderValue(item?.rHours)}}h</span>
              </p>
            </div>
            <div class="min-w-[128px] text-center border border-dashed border-[#C4CADA] rounded-[6px] lg:py-1.5 py-1 px-1 lg:px-3 bg-[#FAF5FF]">
              <p class="font-normal lg:text-sm text-xs text-[#60646C] lg:leading-4 leading-3">
                Overtime:<span
                  class="font-medium text-[#15191E] inline-block">{{formatHeaderValue(item?.otHours)}}h</span>
              </p>
            </div>
          </div>

          <div class="flex items-center lg:gap-2.5 gap-1">
            <!-- Save button only visible when expanded -->
            @if (expandedIndex === i){
            <div *ngIf="!isCompleted" class="p-2 border border-[#C4CADA] flex justify-center items-center rounded-md cursor-pointer" matTooltip="Save"
              (click)="onSubmitLaborHours( i)" (keydown.enter)="onSubmitLaborHours(i)" role="button" tabindex="0">
              <img ngSrc="../../../../../../assets/images/icons/ticket-detail/tick.svg" height="12" width="12"
                alt="Save">
            </div>
            }
            <!-- Edit button visible when collapsed -->
            <div *ngIf="checkUserPermissions('write:changelabhrs')" class="p-2 border border-[#C4CADA] flex justify-center items-center rounded-md cursor-pointer" [matTooltip]="expandedIndex===i? 'Close' : 'Edit'"
              (click)="toggle(i)" (keydown.enter)="toggle(i)" role="button" tabindex="0" [ariaDisabled]="true">
              <img
                [ngSrc]="'../../../../../../assets/images/icons/ticket-detail/' + (expandedIndex === i ? 'Close' : 'edit') + '.svg'"
                height="12" width="12" [alt]="expandedIndex === i ? 'Close' : 'Edit'" />
            </div>
          </div>
        </div>
      </div>

      <!-- Accordion Body Start -->
      <div [@expandCollapse]="expandedIndex === i ? 'expanded' : 'collapsed'" role="region"
        [attr.id]="'accordion-body-' + i" [attr.aria-labelledby]="'accordion-header-' + i" class="overflow-hidden">
        <div class="border-b border-[#EFF0F5] p-4">
          <div class="p-3 bg-[#EFF6FF] rounded-md">
            <h3 class="font-normal text-xs text-[#1D4ED8] leading-4 uppercase mb-2">Worker Hours</h3>
            <div class="flex flex-col lg:flex-row gap-2">
              <div class="flex-1">
                <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                  <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                    for="Estimated{{i}}">Estimated</label>
                  <input type="text" (input)="onChangeEstimatedHours($event, i)"
                    [ngModel]="findWorkerEstimatedHrs(item.id, this.laborRateType.Regular)" [maxLength]="6"
                    class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                    id="Estimated{{i}}" placeholder="Add Here">
                </div>
              </div>
              <div class="flex-1">
                <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                  <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                    for="Regular{{i}}">Regular</label>
                  <input type="text" (input)="onChangeRegularHours($event, i)"
                    [ngModel]="findWorkerHrs(item.id, this.laborRateType.Regular)" [maxLength]="6"
                    class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                    id="Regular{{i}}" placeholder="Add Here">
                </div>
              </div>
              <div class="flex-1">
                <div class="bg-white px-3 py-2 border border-[#D6D7DC] rounded">
                  <label class="font-normal text-xs text-[#60646C] leading-4 mb-[3px] block"
                    for="Overtime{{i}}">Overtime</label>
                  <input type="text" (input)="onChangeOverTimeHours($event, i)"
                    [ngModel]="findWorkerHrs(item.id, this.laborRateType.OverTime)" [maxLength]="6"
                    class="font-medium text-sm text-[#15191E] leading-4 focus:outline-none placeholder-[#60646C] w-full"
                    id="Overtime{{i}}" placeholder="Add Here">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </cdk-accordion-item>
  </cdk-accordion>
</div>
